import { CircularProgress, ClickAwayListener } from "@mui/material";
import { CheckCircleRounded } from "@mui/icons-material";
import { useEffect, useCallback, FC, ReactNode } from "react";
import ReactDOM from "react-dom";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import { Button, Paper } from "..";

export type JModalCustomModalProps = {
  message?: string;
  labelOk?: string;
  labelCancel?: string;
  onConfirm?: () => void;
  onClose?: () => void;
  hideConfirm?: boolean;
  hideClose?: boolean;
  children?: ReactNode;
  isLoading?: boolean;
  disabledConfirm?: boolean;
};
const JModal: FC<JModalCustomModalProps> = ({
  message,
  labelOk = "Ok",
  labelCancel = "Cancel",
  onConfirm = () => {},
  onClose = () => {},
  hideConfirm = false,
  hideClose = false,
  children,
  isLoading,
  disabledConfirm = false,
}) => {
  const domElemToAppendTo = document.getElementById("modal-root");

  const handleEscape = useCallback(
    (e: any) => {
      if (e.keyCode === 27) {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    const keyup: any = document.addEventListener("keyup", handleEscape);

    return () => document.removeEventListener("keyup", keyup);
  }, [handleEscape]);

  return (
    domElemToAppendTo &&
    ReactDOM.createPortal(
      <div
        className="modal is-active is-clipped"
        style={{
          position: "fixed",
          zIndex: 9991,
          backgroundColor: "rgba(0,0,0,0.6)",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ClickAwayListener onClickAway={onClose}>
          <div>
            <Paper
              style={{
                maxWidth: "80vw",
                minWidth: 500,
                maxHeight: "90vh",
                flexDirection: "column",
              }}
            >
              <div style={{ padding: "30px 30px 0 30px" }}>
                {message && <p>{message}</p>}

                <div>{children}</div>
              </div>

              {(!hideConfirm || !hideClose) && (
                <div
                  className="buttons"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: 30,
                    flexDirection:
                      hideClose && !hideConfirm ? "row-reverse" : "row",
                  }}
                >
                  {!hideClose && (
                    <Button onClick={onClose}>
                      <CloseLineIcon style={{ marginRight: 8 }} />
                      {labelCancel}
                    </Button>
                  )}

                  {!hideConfirm && (
                    <Button
                      onClick={onConfirm}
                      disabled={isLoading || disabledConfirm}
                    >
                      {isLoading ? (
                        <CircularProgress color="inherit" size={16} />
                      ) : (
                        <>
                          <CheckCircleRounded
                            style={{
                              marginRight: 8,
                            }}
                          />
                          {labelOk}
                        </>
                      )}
                    </Button>
                  )}
                </div>
              )}
            </Paper>
          </div>
        </ClickAwayListener>
      </div>,
      domElemToAppendTo
    )
  );
};

export default JModal;
